import {
    SCHEDULED_ACTIONS_OPEN_MODAL,
    SCHEDULED_ACTIONS_REQUEST,
    SCHEDULED_ACTIONS_RESULT,
} from 'Redux/actionTypes';

export const scheduledActionsOpenModal = (ids) => ({
    type: SCHEDULED_ACTIONS_OPEN_MODAL,
    payload: ids
})

export const scheduledActionsRequest = (data) => ({
    type: SCHEDULED_ACTIONS_REQUEST,
    payload: data
})

export const scheduledActionsResult = (result) => ({
    type: SCHEDULED_ACTIONS_RESULT,
    payload: result
})